import React from 'react';
import PageMenu from '../../components/PageMenu';

function ContactMenu() {
  return (
    <PageMenu
      title="Contact Menu"
      items={[
        {
          name: 'contact-us',
          title: 'Information Request',
        },
        {
          name: 'customer-care',
          title: 'Customer Care',
        },
        {
          name: 'service-request',
          title: 'Service Request',
        },
        // {
        //   name: 'careers',
        //   title: 'Careers',
        // },
      ]}
    />
  );
}

export default ContactMenu;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ContactMenu.js